// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { BunzlActionUnion } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { Draft } from "immer";

export interface AuthorizedPickUpPersonState {
    cartId?: string;
    authorizedPickUpPerson: string;
    isApplicable: boolean;
    showError: boolean;
}

const initialState: AuthorizedPickUpPersonState = {
    authorizedPickUpPerson: "",
    isApplicable: false,
    showError: false,
};

const actions = {
    "Store/Pages/CheckoutReviewAndSubmit/SetAuthorizedPickUpPersonState": (
        draft: Draft<AuthorizedPickUpPersonState>,
        action: { state: Partial<AuthorizedPickUpPersonState> },
    ) => {
        Object.assign(draft, action.state);
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type AuthorizedPickUpPersonActions = BunzlActionUnion<typeof actions>;
export default reducer;
